import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresAgregarIndividualLista', {
    template: template,
    controller: NominasNominaColaboradoresAgregarIndividualListaComponent,
    bindings: {
      empleados: '<',
      onSelect: '&',
    },
  })

function NominasNominaColaboradoresAgregarIndividualListaComponent($filter) {
  let $ctrl = this,
    filterBy = $filter('filter')

  $ctrl.$onInit = $onInit
  $ctrl.filtrar = filtrar
  $ctrl.seleccionar = seleccionar

  function $onInit() {
    $ctrl.resultados = undefined
    $ctrl.filtro = ''
    filtrar()
  }

  function filtrar() {
    $ctrl.resultados = filterBy($ctrl.empleados, $ctrl.filtro)
  }

  function seleccionar(item) {
    let data = angular.extend({
      percepciones: {},
      deducciones: {},
    }, item)

    $ctrl.onSelect({$event: {data: data}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/agregar/individual/lista/component.js